import { DonationCTASection } from "@/templates/sections/DonationCTASection"
import { getSectionVariant } from "./variants"
import { DonationCtaSplitPanel, DonationCtaFloatingCard } from "./donation_cta_variants"
import { wrapWithBackgroundIfNeeded, type BlockComponentProps } from "./shared"

/**
 * `banner` (default / unknown variant) is the original DonationCTASection,
 * unchanged for all existing sections. All layouts keep the shared
 * background-image wrapper so `content.background_image` behaves the same
 * regardless of variant.
 */
export function DonationCtaBlock(props: BlockComponentProps) {
  const { content, customizations, org, styleOverrides } = props
  const inner = (() => {
    switch (getSectionVariant(content)) {
      case "split-panel":
        return <DonationCtaSplitPanel {...props} />
      case "floating-card":
        return <DonationCtaFloatingCard {...props} />
      default:
        return (
          <DonationCTASection
            content={content}
            customizations={customizations}
            org={org}
            styleOverrides={styleOverrides}
          />
        )
    }
  })()
  return <>{wrapWithBackgroundIfNeeded(content, inner)}</>
}
